const registerPromote = () => import("../../views/channelPromotion/registerPromote.vue");
// const registerPromote = () => import("../../views/channelPromotion/components/Certification.vue");
const modifyUserChannels = () => import("../../views/channelPromotion/modifyUserChannels.vue");

const Container = {
    template: `
    <div style="height: 100%">
      <router-view></router-view>
    </div>
  `,
};

const router = {
    path: '/channel',
    name: 'Channel',
    component: Container,
    children: [
        {
            path: '/registerPromote',
            name: 'registerPromote',
            component: registerPromote,
            meta: {
                title:"睿鹰急救天眼"
            }
        },
        {
            path: '/modifyUserChannels',
            name: 'modifyUserChannels',
            component: modifyUserChannels,
            meta: {
                title:"睿鹰急救天眼"
            }
        }
    ]
}


export default router;



// WEBPACK FOOTER //
// ./src/router/modules/channelPromotion.js